import React from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import {
  BroadcastMobIcon,
  LiveChatMobIcon,
  LogIcon,
} from "../../assets/svg/mobileIcon";
import { PRACTICE_EDITION_WHITELABEL } from "../../constants/constants";
import "./styles.scss";

const MobileMenu = (props) => {
  const { user } = props;
  const liveChatPermission = user && user.liveChatAccess;
  const broadcastPermission = user && user.broadcastAccess;
  if (!PRACTICE_EDITION_WHITELABEL) {
    return (
      <>
        <div className="menu-tab">
          <div className="nav-flex">
            {liveChatPermission !== 0 && (
              <NavLink to="/chat" className="tab">
                <div className="nav-item">
                  <div
                    className={
                      props.component === "liveChat"
                        ? "label-background-selected"
                        : "label-background"
                    }
                  >
                    <LiveChatMobIcon />
                  </div>
                  <span className="item-label">Live Chat</span>
                </div>
              </NavLink>
            )}
            {broadcastPermission !== 0 && (
              <NavLink to="/broadcast" className="tab">
                <div className="nav-item">
                  <div
                    className={
                      props.component === "broadcast"
                        ? "label-background-selected"
                        : "label-background"
                    }
                  >
                    <BroadcastMobIcon />
                  </div>
                  <span className="item-label">Broadcast</span>
                </div>
              </NavLink>
            )}
            <NavLink to="/logs" className="tab">
              <div className="nav-item">
                <div className={"label-background"}>
                  <LogIcon />
                </div>
                <span className="item-label">Logs</span>
              </div>
            </NavLink>
          </div>
        </div>
      </>
    );
  }
  return null;
};

const mapStateToProps = (state) => ({
  user: state.login.user,
});

export default withRouter(connect(mapStateToProps)(MobileMenu));
